import GrpcRioClient from './grpc';
import initClient from './grpc/initClient';
export { initClient };
export default GrpcRioClient;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/client/index.js
// module id = 1433
// module chunks = 11